import { cva } from "./cva.ts"

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={classForSkeleton({ className })} {...props} />
}

export const classForSkeleton = cva("animate-pulse bg-gray-3")
